module.exports = __webpack_public_path__ + "static/media/HK.b00efebf.jpg";